export const CACHE_KEYS = {
  minimalProfile: "worksphere_profile_minimal",
  dashboardSummary: "worksphere_dashboard_summary",
  hrStats: "worksphere_hr_stats",
  leaveHistory: "worksphere_leave_history",
  leaveBalances: "worksphere_leave_balances",
  dashboardWeather: "worksphere_dashboard_weather",
  dashboardQuote: "worksphere_dashboard_quote",
};

export const readCachedValue = (key, maxAgeMs) => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const rawValue = window.localStorage.getItem(key);
    if (!rawValue) {
      return null;
    }

    const parsed = JSON.parse(rawValue);
    if (
      !parsed ||
      typeof parsed !== "object" ||
      typeof parsed.timestamp !== "number" ||
      !("data" in parsed)
    ) {
      return null;
    }

    if (
      typeof maxAgeMs === "number" &&
      Number.isFinite(maxAgeMs) &&
      Date.now() - parsed.timestamp > maxAgeMs
    ) {
      return null;
    }

    return parsed.data;
  } catch (error) {
    return null;
  }
};

export const writeCachedValue = (key, data) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({
        timestamp: Date.now(),
        data,
      }),
    );
  } catch (error) {
    // Ignore storage write failures.
  }
};

export const clearCachedValue = (key) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // Ignore storage removal failures.
  }
};
